<template>
  <div class="container" v-drag-and-drop:options="dropOptions">
    <el-row :gutter="5" class="class-dish" type="flex">
      <el-card
        class="box-card"
        :body-style="{ padding: '10px', height: '300px','overflow-y': 'scroll'}"
      >
        <div slot="header" class="clearfix">
          <h2 class="header-title">标准碗碟库</h2>
          <el-button type="text" @click="emitAddClassDish">添加标准碗碟</el-button>
          <div class="btn-wrapper-1">
            <el-button type="success" size="mini" @click="submitMarkedData">标注完成</el-button>
          </div>
        </div>
        <div class="image-wrapper">
          <!--碗碟drop区域-->
          <div class="drag-image-wrapper item" v-for="dishModel in classDishListAfterAdd" :key="dishModel.class_id"
               :data-id="dishModel.class_id">
            <div class="dish-wrapper" :class="{'dish-wrapper-added': dishModel.added && dishModel.added === true}">
              <el-badge
                :value="markedImageListFilter[dishModel.class_id] ? markedImageListFilter[dishModel.class_id].length
                : 0"
                class="undraggable class-image-wrapper"
              >
                <classDishWrapper :image="dishModel" class="class-dish-wrapper"></classDishWrapper>
              </el-badge>
              <el-popover
                ref="popover1"
                placement="top-start"
                v-for="dish in markedImageListFilter[dishModel.class_id]"
                alt
                :key="dish.dish_image_url"
                trigger="click">
                <img :src="dish.dish_img_url" slot="reference" width="20" height="20">
                <div class="big-image-wrapper">
                  <img :src="dish.dish_img_url" width="100px" alt>
                  <el-button type="text" class="unmark-btn" @click="unmark(dish)">撤回</el-button>
                </div>
              </el-popover>
            </div>
          </div>
        </div>
      </el-card>
      <el-card class="box-delete">
        <div slot="header">
          <h2 class="danger-text header-title">回收站</h2>
        </div>
        <!--// 回收站drop区域-->
        <div class="drag-image-wrapper" :data-id="-1">
          <div class="image-item" v-for="dish in deletedImageList" :key="dish.dish_uuid">
            <el-popover ref="popover1" placement="top-start" trigger="hover">
              <img :src="dish.dish_img_url" slot="reference" alt width="20" height="20">
              <div class="big-img-wrapper">
                <el-button
                  type="primary"
                  class="btn"
                  style="position: absolute" @click="unmark(dish)">撤回</el-button>
                <img :src="dish.dish_img_url" alt width="150px"></div>
            </el-popover>
          </div>
        </div>
      </el-card>
    </el-row>
    <h2 class="process-title">
      从下列图片中选择与例图
      <span class="strong-text">相符的碗碟</span>拖动标记, 无效图片请拖至回收站
      <div class="tag-wrapper">
        <el-badge :value="batchImageListMarkedCount" class="item">
          <el-tag type="success">已标记</el-tag>
        </el-badge>
        <el-badge :value="batchImageListUnmarkedCount" class="item">
          <el-tag type="danger">未标记</el-tag>
        </el-badge>
        <el-badge :value="batchImageListDeleteCount" class="item">
          <el-tag type="danger">已删除</el-tag>
        </el-badge>
      </div>
    </h2>

    <div class="images-wrapper drag-image-wrapper" v-if="batchImageListUnmarkedCount">
       <div class="image-item-wrapper drag-item"
            v-for="image in currentImages"
            :data-id="image.dish_img_uuid"
            :key="image.dish_img_uuid">
            <image-item :dish_img_uuid="image.dish_img_uuid"
                        :image="image">
            </image-item>
       </div>
      <div class="pagination">
      <el-pagination
        background
        layout="prev, pager, next"
        @current-change="handlePagination"
        :page-count="maxSize"
      >
      </el-pagination>
    </div>
    </div>
    <h3 class="tip-wrapper" v-else>当前批次标注已完成, 请点击
      <el-button type="success" @click="submitMarkedData" size="mini">标注完成</el-button>辛苦您啦
    </h3>
    <el-dialog
      title="请勾选想要添加的碗碟"
      :visible.sync="addClassDishDialogShow"
      width="60%">
      <div class="btn-wrapper">
        <el-button type="primary" @click="addFromOrigion" :disabled="true">从本地添加</el-button>
        <el-button type="primary" @click="addClassDish">确定</el-button>
        <el-button type="danger" @click="cancelAddClassDish">取消</el-button>
      </div>
      <el-table
        height="60vh"
        :data="allClassListDifferent"
        @selection-change="handleSelect"
        style="width: 100%">
        <el-table-column
          header-align="center"
          align="center"
          type="selection"
          label="#">
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          label="碗碟名称"
        >
          <template slot-scope="scope">
            {{scope.row.dish_native_name ? scope.row.dish_native_name : '暂无名称'}}
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          label="例图">
          <template slot-scope="scope">
            <classDishWrapper :image="scope.row" class="class-dish_wrapper-1"></classDishWrapper>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
    <el-dialog
      title="请填写碗碟信息"
      :visible.sync="classDishMetashow"
      width="30%">
      <el-form ref="form" :model="currentDish" label-width="80px">
        <el-form-item>
          <el-input v-model="currentDish.dish_native_name" placeholder="请输入碗碟名称(碗碟库)"></el-input>
        </el-form-item>
        <el-form-item>
          <el-input v-model="currentDish.dish_native_name" placeholder="请输入碗碟描述"></el-input>
        </el-form-item>
        <el-form-item>
          <el-select v-model="currentDish.dish_type" placeholder="请选择碗碟识别类型">
              <el-option
                v-for="item in dishTypeOptions"
                :key="item.index"
                :label="item.type"
                :value="item.index">
              </el-option>
            </el-select>
        </el-form-item>
        <el-form-item>
          <el-upload
            action=""
            :show-file-list="false"
            :http-request="classDishImageUpload"
            list-type="picture-card"
            class="upload"
          >
            <div class="image-wrapper" v-if="currentDish.dish_image_url">
              <img
                class="image-item avatar"
                :src="currentDish.dish_image_url"
              />
            </div>
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="classDishMetashow = false">取 消</el-button>
        <el-button type="primary" @click="classDishMetashow = false">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script type="">
import {mapGetters, mapMutations} from 'vuex';
import _ from 'lodash';
import classDishWrapper from '_c/classDishWrapper';
import imageItem from '_c/imageItem';
import {apiBackDataMark, apiGetAllClassList} from '@/api';

export default {
  name: 'backDataImageMark',
  components: {
    classDishWrapper,
    imageItem
  },
  data () {
    let that = this;
    return {
      backData: [],
      classDishMetashow: false,
      classDishListAfterAdd: [],
      selectedRow: [],
      pageSize: 60,
      currentPage: 1,
      markImageList: [],
      wrongDishList: [],
      testList: [],
      currentIndex: 0,
      markedObject: {},
      batchImageListDelete: [],
      addClassDishDialogShow: false,
      allClassList: [],
      currentDish: {
        dish_type: '1',
        dish_image_url: '',
        dish_native_name: '',
        dish_desc: ''
      },
      dishTypeOptions: [
        {
          type: '碗碟识别模式',
          index: '1'
        },
        {
          type: '内容识别模式',
          index: '2'
        }
      ],
      dropOptions: {
        dropzoneSelector: '.drag-image-wrapper',
        draggableSelector: '.drag-item',
        onDrop (e) {
          let target_class_id = e.droptarget.dataset.id;
          let items_id = e.items.map((a) => a.dataset.id);
          items_id.forEach((a) => {
            let target = _.find(that.markImageList, (b) => {
              return b.dish_img_uuid === a;
            });
            if (target) {
              that.$set(target, 'class_id', target_class_id);
            }
            console.log(target);
          });
        }
      }
    };
  },
  mounted () {
    this.setSubTitle('回测图片标注');
    // this.getImagesByBatchTag();
    this.addClassDish();
    this.backData = this.$route.params.backData;
    this.markImageList = this.getMarkImageList();
  },
  methods: {
    ...mapMutations([
      'setSubTitle',
      'emitLoading',
      'removeLoading',
      'unMark',
      'setUnMarkedImageList'
    ]),
    classDishImageUpload () {

    },
    addFromOrigion () {
      this.addClassDishDialogShow = false;
      this.classDishMetashow = true;
    },
    handleSelect (rows) {
      rows.forEach(a => {
        this.$set(a, 'added', true);
      });
      this.selectedRow = rows;
    },
    addClassDish () {
      this.addClassDishDialogShow = false;
      this.classDishListAfterAdd = [...this.selectedRow, ...this.modelList];
    },
    cancelAddClassDish () {
      this.addClassDishDialogShow = false;
    },
    async emitAddClassDish () {
      this.addClassDishDialogShow = true;
      try {
        let res = await apiGetAllClassList(this.apiKey);
        this.allClassList = res.dish_info_list;
        console.log(res);
      } catch (e) {
        this.$message.error('获取全部标准碗碟失败' + e.message);
        console.log(e);
      }
    },
    handlePagination (index) {
      this.currentPage = index;
      this.$emit('pageChange', index, index === this.maxSize);
    },
    getMarkImageList () {
      // return this.$store.getters.markImageList();
      let list = this.$route.params.imageList;
      list.forEach(a => {
        a.class_id = '';
      });
      return list || [];
    },
    unmark (dish) {
      let classId = dish.class_id;
      if (Number.parseInt(classId) === -1) {
        this.$set(dish, 'class_id', '');
        let markList = this.batchImageListDelete;
        let idx = this.$_.findIndex(markList, a => {
          return a.dish_img_uuid === dish.dish_img_uuid;
        });
        if (idx !== -1) {
          markList.splice(idx, 1);
        }
      } else {
        let markList = this.markedObject[classId];
        let idx = this.$_.findIndex(markList, a => {
          return a.dish_img_uuid === dish.dish_img_uuid;
        });
        if (idx !== -1) {
          markList.splice(idx, 1);
        }
        let backDataItem = this.backData[classId].currentImages;
        let idx1 = this.$_.findIndex(backDataItem, (a) => {
          return a.dish_img_uuid === dish.dish_img_uuid;
        });
        idx1 !== -1 && backDataItem.splice(idx1, 1);
      }
      let idx2 = this.$_.findIndex(this.markImageList, a => {
        return a.dish_img_uuid === dish.dish_img_uuid;
      });
      this.$set(this.markImageList[idx2], 'class_id', '');
      this.setUnMarkedImageList(this.unMarkedImageList.filter(a => !a.class_id));
    },
    // 保存标记状态到本地
    saveLocal () {},
    // 下一个例图
    nextDishModel () {
      if (this.currentIndex < this.modelList.length) {
        this.currentIndex++;
      }
    },
    // 上一个例图
    preDishModel () {
      if (this.currentIndex > 0) {
        this.currentIndex--;
      }
    },
    async submitMarkedData () {
      if (this.batchImageListUnmarkedCount > 0) {
        this.$confirm('当前还有未标注图片, 是否丢弃剩余图片?', '重要提示', {
          type: 'warning',
          confirmButtonText: '丢弃',
          cancelButtonText: '继续标注'
        }).then(async () => {
          let res = [];
          res = this.markImageList.filter(a => a.class_id === '');
          console.log(res);
          res.forEach(a => {
            this.$set(a, 'class_id', '-1');
            this.batchImageListDelete.push(a);
          });
          // this.resetBackData();
          try {
            await apiBackDataMark(
              this.markImageList,
              this.apiKey,
              this.checkedClassList,
              this.allImageList,
              false,
              this.taskUuid
            );
            this.$message.warning('标注完成');
            if (this.userGroup > 499) {
              this.$router.push({
                name: 'backDataAccByCanteen',
                params: {
                  canteen: this.canteen,
                  dateRange: this.dateRange
                }
              });
            } else {
              this.$router.push({
                name: 'taskAdmin'
              });
            }
          } catch (e) {
            this.$message.error('标注失败' + e.message);
            console.log(e);
          }
        }).catch((e) => {
          console.log(e);
        });
      } else {
        try {
          await apiBackDataMark(
            this.markImageList,
            this.apiKey,
            this.checkedClassList,
            this.allImageList,
            false,
            this.taskUuid
          );
          this.$message.warning('标注完成');
          if (this.userGroup > 499) {
            this.$router.push({
              name: 'backDataAccByCanteen',
              params: {
                canteen: this.canteen,
                dateRange: this.dateRange
              }
            });
          } else {
            this.$router.push({
              name: 'taskAdmin'
            });
          }
        } catch (e) {
          this.$message.error('标注失败' + e.message);
          console.log(e);
        }
      }
    }
  },
  computed: {
    ...mapGetters([
      'currentDishModelIndex',
      'listQuery',
      'userinfo',
      'allImageList',
      'taskUuid'
    ]),
    // 与回测数据中已有有的标准碗碟做补集
    allClassListDifferent () {
      return this.$_.differenceWith(this.allClassList, this.modelList, (left, right) => {
        return left.class_id === right.class_id;
      });
    },
    maxSize () {
      return Math.ceil(this.unMarkedImageList.length / this.pageSize);
    },
    userGroup () {
      return this.userinfo().userGroup;
    },
    canteen () {
      return this.$route.params.canteen;
    },
    markedImageListFilter () {
      let imageList = this.markImageList;
      let res = this.$_.groupBy(imageList, 'class_id');
      return this.$_.pickBy(res, (value, key) => {
        return !!key;
      });
    },
    dateRange () {
      return this.$route.params.dateRange;
    },
    modelList () {
      return this.$route.params.modelList;
    },
    apiKey () {
      return this.$store.getters.userinfo().api_key;
    },
    checkedClassList () {
      return this.$route.params && this.$route.params.checkedClassList
        ? this.$route.params.checkedClassList
        : [];
    },
    unMarkedImageList () {
      return this.markImageList.filter(dish => {
        // return !dish.class_id;
        if (dish.class_id === -1 || dish.class_id === '-1') {
          return false;
        }
        let idx = this.$_.findIndex(
          this.classDishListAfterAdd,
          model => model.class_id === dish.class_id
        );
        console.log(idx);
        return idx === -1;
      });
    },
    deletedImageList () {
      return this.markedImageListFilter.hasOwnProperty('-1') ? this.markedImageListFilter['-1'] : [];
    },
    // 未标记图片
    batchImageListUnmarkedCount () {
      return this.unMarkedImageList.length || 0;
    },
    // 已标注图片个数(包括已删除)
    batchImageListMarkedCount () {
      return this.markImageList.length - this.batchImageListUnmarkedCount - this.batchImageListDeleteCount;
    },
    // 删除图片个数
    batchImageListDeleteCount () {
      return this.deletedImageList && this.deletedImageList.length;
    },
    currentImages () {
      return this.unMarkedImageList.slice(
        (this.currentPage - 1) * this.pageSize,
        this.currentPage * this.pageSize
      );
    }
  },
  watch: {}
};
</script>
<style lang="scss" scoped>
.container {
  .header-title {
    display: inline-block;
  }
  .tip-wrapper {
    display: inline-block;
    width: auto;
    padding: 20px;
    border: 2px solid red;
    border-radius: 20px;
  }
  .process-title {
    .strong-text {
      color: #65c13e;
    }
    .tag-wrapper {
      padding-left: 10px;
      display: inline-block;
    }
  }
  .box-card {
    width: 90%;
    .btn-wrapper-1 {
      display: inline-block;
      margin-top: -10px;
      float: right;
    }
    .image-wrapper {
      width: auto;
      height: auto;
      .drag-image-wrapper {
        text-align: center;
        .class-image-wrapper {
          display: block;
        }
      }
    }
  }
  .btn-wrapper {
    position: absolute;
    right: 0;
    top: 0;
    padding: 10px;
  }
  .image-wrapper {
    vertical-align: top;
    .item {
      display: inline-block;
      vertical-align: top;
      width: 120px;
      margin: 0 5px;
      min-height: 120px;
      text-align: center;
      border: 2px solid #ccc;
      .class-image-wrapper {
        width: 100px;
      }
      .dish-wrapper {
        padding-top: 5px;
        &.dish-wrapper-added {
          background-color: rgb(28, 158, 251);
        }
      }
      .dragg {
        .chosing {
          background-color: red;
        }
        .image-wrapper-1 {
          width: 100px;
          height: 100px;
          .image-item {
            width: auto;
            height: auto;
            max-width: 100%;
            max-height: 100%;
          }
        }
      }
    }
  }
  .class-dish-wrapper {
  }
  .images-wrapper {
  }
  .big-image-wrapper {
    position: relative;
    .unmark-btn {
      position: absolute;
      z-index: 10;
      right: 0;
      top: 0;
    }
  }
  .box-delete {
    .drag-image-wrapper {
      width: 100px;
      height: 250px;
      overflow-y: scroll;
      .image-item {
        display: inline-block;
      }
    }
  }
  .drag-item {
    display: inline-block;
    margin: 10px;
    background: rgba(black, 0.4);
    /* items grabbed state */
    &[aria-grabbed="true"] {
      background: #5cc1a6;
      color: #fff;
    }
    .drag-item-text {
      font-size: 1rem;
      padding-left: 1rem;
      padding-top: 1rem;
    }
  }
  .pagination {
    margin: 10px 0;
    width: 100%;
    text-align: center;
  }
  .class-dish_wrapper-1 {
    display: inline-block;
    width: 50px;
    height: 50px;
  }
}
</style>
